export default "__VITE_ASSET__9d53af0c__"